const initialState = {
  current: 'id',
};

function language(state = initialState, action) {
  switch (action.type) {
    case 'RECEIVE_CHANGE_LANGUAGE':
      return {
        ...state,
        current: action.current,
      };
    default:
      return state;
  }
}

export default language;
